import React, { Component } from "react";
import { connect } from "react-redux";
import FlatButton from "material-ui/FlatButton";
import FileIcon from "material-ui/svg-icons/file/file-upload";
import CloseIcon from "material-ui/svg-icons/navigation/close";

import { renderMerchantHeaderInfos } from "./utils";
import { loadTos, uploadProgress, uploadDone, deleteTos } from "./actions";
import { checkPrivileges } from "../auth/privileges";
import auth from "../auth/constants";

import "./common.css";
import "./Tos.css";

class Tos extends Component {
  componentDidMount() {
    this.props.loadTos(this.props.merchant.code);
  }

  handleUpload = target => e => {
    setTimeout(() => {
      // Animation purpose
      document.getElementById(target).click();
    }, 400);
  };

  handleDelete = kind => e => {
    const code = this.props.merchant.code;
    this.props.deleteTos(code, kind);
  };

  progressUpload = kind => e => {
    const percentage = Math.ceil(100 * (e.loaded / e.total));
    this.props.uploadProgress(kind, percentage);
  };

  progressLoad = (kind, xhr) => e => {
    if (xhr.readyState === 4) {
      const data = JSON.parse(xhr.responseText);
      this.props.uploadDone(data);
    }
  };

  handleFileUpload = kind => e => {
    const file = e.target.files[0];
    const formData = new FormData();
    const code = this.props.merchant.code;
    formData.append("file", file);

    const xhr = new XMLHttpRequest();
    xhr.upload.addEventListener("progress", this.progressUpload(kind), false);
    xhr.addEventListener(
      "readystatechange",
      this.progressLoad(kind, xhr),
      false
    );
    xhr.open("POST", `/api/merchants/${code}/tos/${kind}`, true);
    xhr.setRequestHeader("Authorization", this.props.token);
    xhr.send(formData);
  };

  renderProgressBar = tos => {
    return tos.percentage ? (
      <div className="progress-bar">
        <div className="progress" style={{ width: tos.percentage }} />
      </div>
    ) : null;
  };

  renderExistingTos = (libelle, tos, kind) => {
    return (
      <div className="card tos tos-country">
        <div className="label">{libelle}</div>
        <p>
          <a href={tos.url} target="_blank" rel="noopener noreferrer">
            Voir les CGV
          </a>
        </p>
        <FlatButton
          label="Supprimer"
          icon={<CloseIcon />}
          onClick={this.handleDelete(kind)}
        />
      </div>
    );
  };

  renderTos = (libelle, tos, kind) => {
    return tos.available ? (
      this.renderExistingTos(libelle, tos, kind)
    ) : (
      <div className="card tos tos-country">
        <div className="label">{libelle}</div>
        <p>Aucun fichier de CGV.</p>
        <FlatButton
          label="Ajouter"
          icon={<FileIcon />}
          onClick={this.handleUpload("uploader-" + kind)}
        />
        <div className="file-wrapper">
          <input
            type="file"
            id={"uploader-" + kind}
            onChange={this.handleFileUpload(kind)}
          />
        </div>
        {this.renderProgressBar(tos)}
      </div>
    );
  };

  render() {
    const { mainResortLibelle, libelle } = this.props.merchant;
    const { user } = this.props;
    const { fr, en } = this.props.tos;
    if (!fr || !en) return null;
    return (
      <div className="cards-container">
        <div className="card tos">
          {renderMerchantHeaderInfos(
            checkPrivileges(user.privileges, auth.DISPLAY_MERCHANT_HEADER),
            libelle,
            mainResortLibelle
          )}
          <div className="title">CGV</div>
          <div className="inner">Liste des conditions générales de ventes</div>
          <div className="warning">
            Les CGV doivent être importées au format PDF
          </div>
        </div>
        <div className="tos-countries cards">
          {this.renderTos("En français", fr, "fr")}
          {this.renderTos("En anglais", en, "en")}
        </div>
      </div>
    );
  }
}

/********* Container part */

const mapStateToProps = state => ({
  merchant: state.merchant.detail,
  tos: state.merchant.tos,
  user: state.app.auth.user,
  token: state.app.auth.token
});

const mapDispatchToProps = dispatch => ({
  loadTos: code => {
    dispatch(loadTos(code));
  },
  uploadProgress: (kind, percentage) => {
    dispatch(uploadProgress(kind, percentage));
  },
  uploadDone: kind => {
    dispatch(uploadDone(kind));
  },
  deleteTos: (code, kind) => {
    dispatch(deleteTos(code, kind));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Tos);



// WEBPACK FOOTER //
// ./src/merchant/Tos.js